<template>
    <div>
        <div class="content-header">
            <h3>订单查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item label="主单号">
                    <el-input v-model="formInline.orderMainNo" placeholder="请输入主订单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="子单号">
                    <el-input v-model="formInline.orderNo" placeholder="请输入子订单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="收货人">
                    <el-input v-model="formInline.consigneeName" placeholder="请输入收货人" clearable></el-input>
                </el-form-item>
                <el-form-item label="收货人电话">
                    <el-input v-model="formInline.consigneePhone" placeholder="请输入收货人电话" clearable></el-input>
                </el-form-item>
                <el-form-item label="openId">
                    <el-input v-model="formInline.openId" placeholder="请输入openId" clearable></el-input>
                </el-form-item>
                <el-form-item label="开始日期">
                    <el-date-picker
                            v-model="formInline.start"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="不选择默认查询当天">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker
                            v-model="formInline.end"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="btnGetQueryOrderList">查询</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="主订单号" prop="orderMainNo"></el-table-column>
                <el-table-column label="昵称" prop="nickName"></el-table-column>
                <el-table-column label="头像" prop="orderMainNo">
                    <template slot-scope="scope">
                        <img :src="scope.row.headImageUrl" width="60" height="60" class="head_pic"/>
                    </template>
                </el-table-column>
                <el-table-column prop="orderSourceName" label="订单来源"></el-table-column>
                <el-table-column prop="statusClassName" label="订单类型"></el-table-column>
                <el-table-column prop="statusName" label="订单状态"></el-table-column>
                <el-table-column prop="createTime" label="创单时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="220">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="warn" size="mini" @click="hideOrder(scope.row.orderMainNo)">隐藏订单</el-button>
                            <el-button type="success" size="mini" @click="handleDetail(scope.row.customerId)">客户详情</el-button>
                            <el-button type="primary" size="mini" @click="toOrderDetail(scope.row.orderMainNo)">订单详情</el-button>
                            <el-button type="success" size="mini" @click="syncOMSOrder(scope.row.orderMainNo)">同步OMS</el-button>
                            <el-button type="success" size="mini" @click="syncStatusEdbOrder(scope.row.orderMainNo)">同步支付成功</el-button>
                        </el-button-group>

                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
        </div>
        <el-drawer
                title="嵌入ERP老页面"
                :visible.sync="drawerShow"
                direction="rtl"
                :before-close="handleClose"
                size="70%">
            <iframe :src="toUrl" width="100%" height="100%"></iframe>
        </el-drawer>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {queryOrderList,hideOrder} from '@/api/api';
    import {omsOrderSyncQuartz, omsOrderSyncStatus} from "../../api/api";


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    orderMainNo:this.$route.query.orderMainNo||'',
                    orderNo: '',
                    start:'',
                    end:'',
                    consigneeName:'',
                    consigneePhone:'',
                    openId:''
                },
                recordsTotal:0,
                drawerShow:false,
                toUrl:''
            }
        },
        //挂载时候执行
        mounted() {
            this.getQueryOrderList();
        },
        methods: {
            //定义查询方法
            getQueryOrderList() {
                this.loading = true;
                queryOrderList(this.formInline).then((res) => {
                    this.dataList = res.data.value.list
                    this.recordsTotal = res.data.value.total
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getQueryOrderList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getQueryOrderList()
            },
            hideOrder(orderMainNo){
                this.$confirm('是否隐藏订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    hideOrder({"orderMainNo":orderMainNo}).then((res) => {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    });
                });
            },
            handleDetail(row) {
                this.$router.push({path:'/userSystem/detail/:id',name: 'userSystemContent',params:{id:row}})
            },
            toOrderDetail(orderNo){
                this.drawerShow = true
                if(window.location.href.indexOf('check')!= -1){
                    //测试环境
                    this.toUrl = `http://erptest.lechun.cc/admin_sold_show.html?SOLD_ID=${orderNo}`+'&userName='+  window.localStorage.getItem('loginUser');
                }else {
                    //生产环境
                    this.toUrl = `//erpnew.lechun.cc/admin_sold_show.html?SOLD_ID=${orderNo}`+'&userName='+  window.localStorage.getItem('loginUser');
                }
            },
            syncStatusEdbOrder(orderMainNo){
                omsOrderSyncStatus({'orderMainNo':orderMainNo}).then((res) => {
                    this.loading = true;
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getUnsyncEDBOrders();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            syncOMSOrder(orderMainNo){
                omsOrderSyncQuartz({'orderMainNo':orderMainNo}).then((res) => {
                    this.loading = true;
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getUnsyncEDBOrders();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleClose(done){
                done()
                this.getQueryOrderList()
            },
            btnGetQueryOrderList(){
                this.getQueryOrderList()
                this.formInline.currentPage = 1
            },
            GetQueryString(name){
                let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                let sp = '?'
                let arr=window.location.href.split(sp);
                if(arr.length>=2){
                    let u=arr[1].substr(1);
                    u= u.replace(/amp;/g,"");
                    let r = u.match(reg);
                    if(r!=null)
                        return  decodeURIComponent(r[2]);
                }
                return(false);
            }
        }
    }
</script>
<style scoped lang="scss" rel="stylesheet/scss" >
    .select-wrap{
        margin: 10px 10px 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/order/queryOrder.vue